import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import styles from './CTA.scss';

const CallToAction = ({
  image, header, content, fonts, numCols,
}) => {
  const gridSpacing = 12 / numCols;

  return (
    <Col xs={6} sm={gridSpacing}>
      <div className={styles.align}>
        <div className={styles.imgWrapper}>
          {image}
        </div>
        <div
          className={styles.header}
          style={{ fontFamily: fonts.secondary.name }}
        >
          <div className={styles.headerStyles}>
            {header}
          </div>
        </div>
        <div className={styles.text} style={{ fontFamily: fonts.primary.name }}>
          <div className={styles.textStyles}>
            {content}
          </div>
        </div>
      </div>
    </Col>
  );
};

CallToAction.propTypes = {
  image: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  fonts: PropTypes.object.isRequired,
  numCols: PropTypes.string.isRequired,
};

export default CallToAction;
